module.exports = __webpack_public_path__ + "static/img/jchb1-11.91c2cb5.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/layout/jchb1-11.png
// module id = 773
// module chunks = 0